angular.module('smartorg.r6.mgmts.assignCategory', [
    'ui.grid',
    'ui.grid.resizeColumns'
]);
require('./assign-category-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.assignCategory';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/assign-category/app/js/plumbing/app.js